__turbopack_context__.v({
  "servicesPadding": "Review-module-scss-module__R8iSPW__servicesPadding",
});
